import { PERSONAL_PAGE_SUBTYPE_LABELS } from '../../labels';
import { cap } from '../capability-builder';
import { emptyLabels, serviceLabels, serviceOptions } from '../item-presets';
import type { PersonalPageCapabilities } from '../types';

export const informationCapabilities: Record<string, PersonalPageCapabilities> = {
  serviceRegistration: cap({
    label: PERSONAL_PAGE_SUBTYPE_LABELS.serviceRegistration.singular,
    hasStartEndRange: true,
    itemKind: 'service',
    itemOptions: serviceOptions,
    dataDestination: 'registrations',
    itemLabels: serviceLabels,
    defineStepLabelConfig: {
      formSubject: 'הרשמה',
      overrides: {
        registrationLimitTitle: 'מכסה כוללת לדף',
        registrationLimitSubtitle: 'הגבלת סך ההרשמות בדף (בנוסף למלאי לכל סוג שירות)',
        ticketSection: {
          title: 'סוגי שירותים',
          description: 'הוסף ונסה סוגי שירותים שונים',
          buttonText: 'הוסף סוג שירות חדש',
          emptyText: 'אין סוגי שירותים מוגדרים עדיין. לחץ על "הוסף סוג שירות חדש" כדי להתחיל.',
          addTitle: 'הוספת סוג שירות חדש',
          editTitle: 'עריכת סוג שירות',
          deleteTitle: 'מחיקת סוג שירות',
          deleteConfirmTitle: 'סוג שירות',
          priceRowLabel: 'מחיר',
          inventoryRowLabel: 'מלאי',
          amountFieldLabel: 'כמות'
        }
      }
    }
  }),

  leads: cap({
    label: PERSONAL_PAGE_SUBTYPE_LABELS.leads.singular,
    allowDonationAtEnd: true,
    dataDestination: 'registrationsAndLeads',
    itemLabels: emptyLabels,
    defineStepLabelConfig: {
      formSubject: 'פנייה'
    }
  }),

  fixedFormLead: cap({
    label: PERSONAL_PAGE_SUBTYPE_LABELS.fixedFormLead.singular,
    hasDefineStep: false,
    dataDestination: 'none',
    defineStepLabelConfig: { formSubject: 'פנייה' }
  })
};
